import { useState } from "react";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import Papa from "papaparse";

const useProductBulkUpload = () => {
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const [inputFile, setInputFile] = useState(null);
  const [productJson, setProductJson] = useState([]);
  const [error, setError] = useState("");
  const [invalidRows, setInvalidRows] = useState([]);
  const [bulkLoader, setBulkLoader] = useState(false);
  const [rejectedRows, setRejectedRows] = useState([]);
  const [openMessage, setOpenMessage] = useState(false);
  const [createstatus, setCreateStatus] = useState("");
  const [isProduct, setIsProduct] = useState("");
  const dispatch = useDispatch();

  const sampleFileUrl1 = `https://vtosandbox.clouddeploy.in/assets/ProductSample.csv`;
  const sampleFileUrl2 = `https://vtosandbox.clouddeploy.in/assets/VariantSample.csv`;

  const handleDownload = () => {
    const link1 = document.createElement("a");
    link1.href = sampleFileUrl1;
    link1.download = "ProductSample.csv";
    document.body.appendChild(link1);
    link1.click();
    document.body.removeChild(link1);
  };

  const handleVariantDownload = () => {
    const link1 = document.createElement("a");
    link1.href = sampleFileUrl2;
    link1.download = "ProductSample.csv";
    document.body.appendChild(link1);
    link1.click();
    document.body.removeChild(link1);
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    setInputFile(file);

    Papa.parse(file, {
      complete: (result) => {
        const jsonData = result.data;
        const structuredData = [];
        const invalidRowsData = [];

        if (jsonData.length === 0) {
          invalidRowsData.push({ rowIndex: 1, item: "Empty feilds" });
          // console.log("jsonData", jsonData);

          setError("There are no values. Please check the file.");
        }

        jsonData.forEach((item, index) => {
          if (Object.values(item).length === 1 && index === 0) {
            setError("There are no values. Please check the file.");
            return;
          }

          if (Object.values(item).length === 1) {
            return;
          }

          if (isProduct === "product") {
            // Product validation

            if (
              !item.SKU ||
              !item.Brand ||
              !item.Name ||
              !item.Gender ||
              !item.ProductType ||
              (item.ProductType.toLowerCase() === "ear" &&
                (!item.Height || !item.Width))
            ) {
              invalidRowsData.push({ rowIndex: index + 1, ...item });
              return;
            }

            const newProductItem = {
              sSKU: item.SKU,
              sStore: item.Brand,
              sName: item.Name,
              sGender: item.Gender,
              sBodyType: item.ProductType,
              ...(item.ProductType.toLowerCase() === "ear" && {
                dHeight: item.Height,
                dWidth: item.Width,
              }),
            };
            structuredData.push(newProductItem);
          } else {
            // Variant validation

            if (!item.SKU || !item.Title || !item.ParentSKU) {
              invalidRowsData.push({ rowIndex: index + 1, ...item });
              return;
            }

            const newVariantItem = {
              sSKU: item.SKU,
              sTitle: item.Title,
              parentSKU: item.ParentSKU,
              dVariantHeight: item.Height ? item.Height : "",
              dVariantWidth: item.Width ? item.Width : "",
            };

            structuredData.push(newVariantItem);
          }
        });
        console.log("structuredData", structuredData);

        setProductJson(structuredData);
        setInvalidRows(invalidRowsData);

        if (invalidRowsData.length > 0) {
          setError(
            `There are ${invalidRowsData.length} invalid rows. Please check the missing fields.`
          );
        } else {
          if (error) {
            setError("");
          }
        }
      },
      header: true,
      error: (error) => {
        console.error("Error parsing file:", error);
        setError("Failed to parse the file.");
      },
    });
  };

  const uploadProducts = async () => {
    try {
      setBulkLoader(true);
      const response = await apiHandler({
        url: endpoint.BULK_PRODUCTS,
        authToken: authData,
        method: "POST",
        data: {
          products: productJson,
          bIsProduct: isProduct === "product" ? 1 : 0,
        },
        storeId,
        dispatch,
      });
      setCreateStatus(response.data.message);
      setInputFile(null);
      if (response.data.status === "success") {
        setError("");
        setInvalidRows([]);
        setProductJson([]);
        setInputFile(null);
      } else {
        setRejectedRows(response.data.data.validationErrors);
      }
      setOpenMessage(true);
    } catch (error) {
      console.log("error in bulk upload products", error);
    } finally {
      setBulkLoader(false);
    }
  };

  return {
    handleFileChange,
    invalidRows,
    error,
    createstatus,
    setInvalidRows,
    setError,
    setOpenMessage,
    handleDownload,
    uploadProducts,
    bulkLoader,
    rejectedRows,
    openMessage,
    setRejectedRows,
    inputFile,
    setProductJson,
    setInputFile,
    handleVariantDownload,
    isProduct,
    setIsProduct,
  };
};

export default useProductBulkUpload;
